export type SupportSelfServiceDetails = {
  documentationUrl: string;
  supportRequestUrl: string;
  supportIncidentUrl: string;
};

export const BACKSTAGE_ASK_A_FRIEND_URL =
  'https://teams.microsoft.com/l/channel/19%3A4644913ae515408a82a7dd69ef2366c3%40thread.tacv2/%E2%9D%93Ask%20a%20friend?groupId=7728d815-73a8-4590-b6a3-db5e52089eff&tenantId=1a41b96d-457d-41ac-94ef-22d1901a7556';

export const BACKSTAGE_DOCUMENTATION_URL =
  'https://dev.azure.com/WSAudiology/SW/_wiki/wikis/CCoE%20Wiki/14963/Backstage';

export const DPE_GENERAL_REQUEST_URL =
  'https://servicedesk.wsa.com/servicedesk/customer/portal/4/create/1899?q=dpe&q_time=1761726967205';

// Eventually, these URLs should be more specific to the current page/location
// For now, they all point to the same default set of URLs, except for the plugins, for which the documentation may be different
export const PATH_MAPPINGS: Record<string, SupportSelfServiceDetails> = {
  default: {
    documentationUrl: BACKSTAGE_DOCUMENTATION_URL,
    supportRequestUrl: DPE_GENERAL_REQUEST_URL,
    supportIncidentUrl: DPE_GENERAL_REQUEST_URL,
  },
  '/deploy-next-app.*': {
    documentationUrl: 'https://dev.azure.com/WSAudiology/SW/_wiki/wikis/CCoE%20Wiki/14380/Deploy-Next-App',
    supportRequestUrl: DPE_GENERAL_REQUEST_URL,
    supportIncidentUrl: DPE_GENERAL_REQUEST_URL,
  },
  '/ccoe-cloud-onboarding.*': {
    documentationUrl: BACKSTAGE_DOCUMENTATION_URL,
    supportRequestUrl: DPE_GENERAL_REQUEST_URL,
    supportIncidentUrl: DPE_GENERAL_REQUEST_URL,
  },
};
